module.exports = __webpack_public_path__ + "img/pfc-thumb2.3e5b5c73.png";